import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * Modal de confirmação para remover um cliente.
 * @param {boolean} show - Controla a visibilidade do modal.
 * @param {Function} handleClose - Função chamada para fechar o modal.
 * @param {Function} handleDelete - Função chamada para confirmar a remoção.
 */
function DeleteClientModal({ show, handleClose, handleDelete }) {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Excluir Cliente</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Deseja mesmo excluir este cliente?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Não
                </Button>
                <Button variant="danger" onClick={handleDelete}>
                    Sim
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteClientModal;
